<!-- <div *ngIf="showContent; else loginTemplate">

  <app-layout *ngIf="!showPasswordPopup && !showSecurityQue && !showSSOlogin && 
         !showResetPassword && !showUnlockAcc && !showSignIn && !showHomePage && 
         !showOtpVerifyPopup && !showQuestionsToAnswer && !showOverdueCompliance && 
         !openHelpDesk && !showActSummary && !showLegalUpdateDetails && 
         !showUpdateDetails && !showInternalOverdueCompliance && !showLogin && !showAuthRedirection">
  </app-layout>
 

  <app-change-password *ngIf="showPasswordPopup"></app-change-password>
  <app-security-questions *ngIf="showQuestionsToAnswer"></app-security-questions>
  <app-change-security-questions *ngIf="showSecurityQue"></app-change-security-questions>
  <app-sso-login *ngIf="showSSOlogin"></app-sso-login>
  <app-reset-password *ngIf="showResetPassword"></app-reset-password>
  <app-unlock-account *ngIf="showUnlockAcc"></app-unlock-account>
  <app-sign-in *ngIf="showSignIn"></app-sign-in>
  <app-home-page *ngIf="showHomePage"></app-home-page>
  <app-overdue-compliance-overview *ngIf="showOverdueCompliance"></app-overdue-compliance-overview>
  <app-help-desk *ngIf="openHelpDesk"></app-help-desk>
  <app-otp-verification *ngIf="showOtpVerifyPopup"></app-otp-verification>
  <app-overdue-internal-compliance-overview
    *ngIf="showInternalOverdueCompliance"></app-overdue-internal-compliance-overview>
  <app-summary-act-details-popup *ngIf="showActSummary"></app-summary-act-details-popup>
  <app-legal-update-details *ngIf="showLegalUpdateDetails"></app-legal-update-details>
  <app-summary-update-details *ngIf="showUpdateDetails"></app-summary-update-details>
  <app-login *ngIf="showLogin"></app-login>
  <app-auth-redirect *ngIf="showAuthRedirection"></app-auth-redirect>
</div>

<ng-template #loginTemplate>
  <app-email-verification></app-email-verification>
</ng-template> -->

<div *ngIf="showResetLinkLoader" class="reset-link-spinner-overlay">
  <div class="spinner"></div>
</div>

<app-session-idle-warning></app-session-idle-warning>
<router-outlet></router-outlet>